export default __webpack_public_path__ + "static/media/SansWeb-LightItalic.e043e4cf.woff";